export const wordTwo = [
  {
    id: 1,
    text: "Vaccine",
    response: "India is a leading exporter of vaccines.",
  },
  {
    id: 2,
    text: "Criticize",
    response: "Constructive criticism leads to improvement.",
  },
  {
    id: 3,
    text: "China",
    response: "China's communist regime restricts freedom.",
  },
  {
    id: 4,
    text: "Social Media",
    response: "Social media have connected people like never before.",
  },
  {
    id: 5,
    text: "Isolation",
    response: "New zealand is geographically isolated.",
  },
  {
    id: 6,
    text: "Quarantine",
    response: "Quarantine prevents spreading of virus.",
  },
  {
    id: 7,
    text: "Fault",
    response: "Consistent practice leads to faultless performance.",
  },
  {
    id: 8,
    text: "Labour",
    response: "Daily wage labours are most affected by Covid.",
  },
  {
    id: 9,
    text: "Grit",
    response: "Grit is the testimony of strong character.",
  },
  {
    id: 10,
    text: "Medical",
    response:
      "Vaccinating a billion-plus citizens is a remarkable medical achievement for India.",
  },
  {
    id: 11,
    text: "Critical",
    response: "Coordination is very critical in team work.",
  },
  {
    id: 12,
    text: "Develop",
    response: "Sri Lanka has developed its economy around tourism.",
  },
  {
    id: 13,
    text: "Children",
    response:
      "Govt. should encourage children adoption for population control.",
  },
  {
    id: 14,
    text: "Nothing",
    response: "There's nothing like a cool swim on a hot day.",
  },
  {
    id: 15,
    text: "Hapless",
    response: "Children in war-torn countries are hapless victims of violence.",
  },
  {
    id: 16,
    text: "Test",
    response: "Life tests everyone in different ways.",
  },
  {
    id: 17,
    text: "Drown",
    response: "Climate change could drown coastal regions.",
  },
  {
    id: 18,
    text: "Friendship",
    response: "Friendship brings joy to life.",
  },
  {
    id: 19,
    text: "Terrain",
    response: "Himalayan terrains are best suited to grow apples.",
  },
  {
    id: 20,
    text: "Veteran",
    response: "Our nation owes its veterans.",
  },
  {
    id: 21,
    text: "Storm",
    response: "Invention of internet took world by storm.",
  },
  {
    id: 22,
    text: "Camp",
    response: "Himachal Pradesh is know for camping vacation.",
  },
  {
    id: 23,
    text: "Avalanche",
    response: "It is common in arctic countries.",
  },
  {
    id: 24,
    text: "Expert",
    response: "Every expert was once a beginner.",
  },
  {
    id: 25,
    text: "Selfish",
    response: "Selfishness is an unattractive trait.",
  },
  {
    id: 26,
    text: "Yield",
    response: "Effort yields results.",
  },
  {
    id: 27,
    text: "Motive",
    response: "One must not be selfish in their motive.",
  },
  {
    id: 28,
    text: "Logic",
    response: "Logic board is an important component of electronic devices.",
  },
  {
    id: 29,
    text: "Gay",
    response: "The repeal of section 377 is a big step for gay rights.",
  },
  {
    id: 30,
    text: "Deteriorate",
    response: "Skills deteriorate without practice.",
  },
  {
    id: 31,
    text: "Attack",
    response: "Covid virus attacks the body's immune system.",
  },
  {
    id: 32,
    text: "Adversity",
    response: "No adversity is too big for those who do not give up.",
  },
  {
    id: 33,
    text: "Plant",
    response: "Indoor plants helps reduce stress level.",
  },
  {
    id: 34,
    text: "Guitar",
    response: "Guitar is a string instrument.",
  },
  {
    id: 35,
    text: "Freedom",
    response: "Freedom is speech is guaranteed in Article 19.",
  },
  {
    id: 36,
    text: "Finance",
    response: "Personal finance should be taught in school.",
  },
  {
    id: 37,
    text: "RAW",
    response: "It was established in 1968 after the Indo-Pak war.",
  },
  {
    id: 38,
    text: "Preparedness",
    response: "Indian Military is always in a state of preparedness.",
  },
  {
    id: 39,
    text: "Minister",
    response: "Ministers holds collective responsibility.",
  },
  {
    id: 40,
    text: "Worry",
    response: "Worry hinders logical thinking.",
  },
  {
    id: 41,
    text: "Betrayal",
    response: "Indulging in bribery is a betrayal to the nation.",
  },
  {
    id: 42,
    text: "Trip",
    response: "Solo trips make us more decisive.",
  },
  {
    id: 43,
    text: "Diverge",
    response: "Political divergence should not cause confilts b/w people.",
  },
  {
    id: 44,
    text: "Lose",
    response: "We never lose if we learn from failure.",
  },
  {
    id: 45,
    text: "Revolution",
    response: "Semiconductor revolutionized electronic industry.",
  },
  {
    id: 46,
    text: "Culpable",
    response: "Inconsistency is a culpable reason for failure.",
  },
  {
    id: 47,
    text: "Guilt",
    response: "Guilt is a form of redemption.",
  },
  {
    id: 48,
    text: "Competitive",
    response: "India has a very competitive job market.",
  },
  {
    id: 49,
    text: "Donation",
    response: "Donating blood helps people in times of need.",
  },
  {
    id: 50,
    text: "Borrow",
    response: "IMF allows countries to borrow from world bank.",
  },
  {
    id: 51,
    text: "Speech",
    response: "Speech can bring about change.",
  },
  {
    id: 52,
    text: "Efficiency",
    response: "Calmness increases efficiency.",
  },
  {
    id: 53,
    text: "Hesitation",
    response: "Hesitation affects confidence.",
  },
  {
    id: 54,
    text: "Accept",
    response: "One must accept their flaws and work on them.",
  },
  {
    id: 55,
    text: "Story",
    response: "Storytelling is persuasive skill.",
  },
  {
    id: 56,
    text: "Missile",
    response: "Agni-V is the most powerful ballistic missile of India.",
  },
  {
    id: 57,
    text: "Satisfaction",
    response: "There is satisfaction in helping others.",
  },
  {
    id: 58,
    text: "Lady",
    response: "Wife of President is regarded as first lady of the country.",
  },
  {
    id: 59,
    text: "Endurance",
    response: "Endurance comes from strong will power.",
  },
  {
    id: 60,
    text: "Concern",
    response: "The government must address the public concerns.",
  },
  {
    id: 60,
    text: "Concern",
    response: "The government must address the public concerns.",
  },
];
